"use client";

import { useTranslations } from "next-intl";

const CARDS = [
	{
		id: "prototyping",
		learnMoreUrl: "/rapid-prototyping",
		cardBgClass: "bg-gray-100",
		headerClass: "text-gray-900",
	},
	{
		id: "production",
		learnMoreUrl: "/cnc-machining",
		cardBgClass: "bg-[#f0fff0]",
		headerClass: "text-[#7cb87c]",
	},
] as const;

export default function PrecisionMachiningSolutionsCards() {
	const t = useTranslations("precisionMachiningSolutions");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				{/* 主标题：两行，第一行 JS Precision 右侧竖线上下居中，第二行 Precision Machining Solutions，左对齐 */}
				<div className="mb-6 flex justify-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-left text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="flex items-center gap-3">
							<span>
								{t("titleLine1Prefix")}
								{t("titleHighlight")}
							</span>
							<div className="h-1 w-24 flex-shrink-0 self-end bg-themePrimary400" aria-hidden />
						</span>
						<span className="mt-2 block sm:mt-3">{t("titleLine2")}</span>
					</h2>
				</div>

				{/* 双卡片 */}
				<div className="grid gap-6 md:gap-8 lg:grid-cols-2">
					{CARDS.map((card) => (
						<div key={card.id} className={`flex flex-col rounded-xl p-6 sm:p-8 ${card.cardBgClass}`}>
							<span className={`mb-2 text-xs font-medium uppercase tracking-wider ${card.headerClass}`}>
								{t(`${card.id}Header`)}
							</span>
							<h3 className="mb-4 text-lg font-bold text-black sm:text-xl md:mb-5 md:text-2xl">
								{t(`${card.id}Title`)}
							</h3>
							<p className="mb-6 flex-1 text-sm leading-relaxed text-black md:text-base">
								{t(`${card.id}Desc`)}
							</p>
							<ul className="mb-6 space-y-1 text-sm text-black md:text-base">
								<li>{t(`${card.id}Spec1`)}</li>
								<li>{t(`${card.id}Spec2`)}</li>
							</ul>
							<a
								href={card.learnMoreUrl}
								target="_blank"
								rel="noopener noreferrer"
								className="group inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white sm:px-6 sm:py-3 sm:text-base"
							>
								{t("learnMore")}
							</a>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
